import { getWindow } from "./armor-system-4JVSZEDO.js";

// src/hooks/useScrollToNode.ts
import { useCallback } from "react";
var win = getWindow();
var defaultScrollOptions = {
  block: "center",
  behavior: "smooth"
};
var useScrollToNode = function useScrollToNode(_ref) {
  var id = _ref.id,
    node = _ref.node,
    className = _ref.className,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? defaultScrollOptions : _ref$options;
  var getCurrentNode = useCallback(function () {
    if (node) {
      return node;
    }
    if (id) {
      return document.querySelector("#".concat(id));
    }
    if (className) {
      return document.querySelector(".".concat(className));
    }
    return null;
  }, [node, id, className]);
  return useCallback(function () {
    if (!win) {
      return;
    }
    setTimeout(function () {
      var currentNode = getCurrentNode();
      if (currentNode) {
        currentNode.scrollIntoView(options);
      }
    }, 0);
  }, [getCurrentNode, options]);
};
export { useScrollToNode };